module.exports = __webpack_public_path__ + "895a79d9303752fdf08889159151e1fe.png";